import type { HelpFile } from '../../types/help'
import { MyResponsibilitiesTestIds, MyResponsibilitiesTabId } from '../../../testids/MyResponsibilitiesTestIds'

export const myResponsibilitiesHelp: HelpFile = {
  docPage: '/docs/my-iam/my-responsibilities',
  texts: {
    [MyResponsibilitiesTestIds.myResponsibilitiesOuterTabs]: null,
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.AccessProfiles)]:
      'Access Profiles for which you are listed as an owner or steward — direct or via team membership.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.FunctionGroups)]:
      'Function Groups for which you are listed as an owner or steward.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.Resources)]:
      'Resources for which you are listed as an owner or steward.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.TargetSystems)]:
      'Target Systems for which you are listed as an owner or steward.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.RestrictionRules)]:
      'Restriction Rules for which you are listed as an owner or steward.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.AutoAssignRules)]:
      'Auto-Assign Rules for which you are listed as an owner or steward.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.CertificationPolicies)]:
      'Certification Policies for which you are listed as an owner or steward.',
    [MyResponsibilitiesTestIds.tab(MyResponsibilitiesTabId.CertificationCampaigns)]:
      'Certification Campaigns for which you are listed as an owner or steward.',
    _section:
      'Catalog entities you are listed as an owner or steward for. Only currently-active ownerships (within their validity window) are shown.',
  },
}
